module.exports = __webpack_public_path__ + "img/myc1.5b10364d.png";